import React from 'react';
import { Box } from '@clariness/clarikit-react';

export const MainPageLayout: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      style={{ overflow: 'hidden' }}
    >
      {children}
    </Box>
  );
};
